import React, { Component } from "react";
import { RESTExecutor, withDomains } from "../../lib/domain";
import {
  Spin,
  Empty,
  Pagination,
  Dropdown,
  Menu,
  Input,
  Button,
  InputNumber,
  DatePicker,
  Tooltip,
  Row,
  Modal,
  Tag,
  Select,
  Badge,
  Table,
} from "antd";
import moment from "moment";
import { OURS_KEY } from "./unreconciled_data";
import { showErrorInNotification, formatMoney, showSuccessInNotification } from "../../lib/util";
import ModalTransactionDetail from "../../components/modal_transaction_detail";
import { TransactionReconcileItem } from "../../components/transaction_reconcile_item";
import { COLORS } from "../theme";
import {
  SyncAltRounded,
  FilterListOutlined,
  ExpandLessOutlined,
  ExpandMoreOutlined,
  RefreshOutlined,
  KeyboardArrowDownOutlined,
} from "@material-ui/icons";
import { CustomSwitch, CustomButton } from "../../components/basic_items";
import ErrorWrapper from "../../lib/error_wrapper";
import lodash from "lodash";
import { PopUpForm } from "../../lib/ui/popupform";

class ManualReconcilerRuleSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: props.type,
      selectedID: null,
      loading: true,
      pageLoading: true,
      error: false,
      filterVisible: false,
      selectedSplitTxnID: null,
      view_transaction_id: null,
      view_transaction_modal: false,
      filter_query: {
        per_page: 20,
        page: 1,
        source_id: this.props.source_id,
      },
      hasFilter: false,
      rowData: [],
      rowMeta: {},
    };
    console.log("manual constructed");

    this.reconciler_id = props.reconciler_id;

    this.splitTransaction = RESTExecutor.post().config({
      label: 'split_unreconciled'
    }).callbacks((success) => {
      this.setState({
        selectedSplitTxnID: null,
        selectedID: null
      })
      this.list_unreconciled_data.execute();
      showSuccessInNotification(success, "Transaction Split Successful");
    }, (error) => {

    }).connect(props.domains.reconciliation);

    this.list_unreconciled_data = RESTExecutor.list()
      .config({
        label:
          props.type === OURS_KEY
            ? "our_manual_unreconciled"
            : "their_manual_unreconciled",
        params: {
          ...this.state.filter_query,
        },
      })
      .callbacks(
        (success) => {
          this.setState({
            loading: false,
            error: false,
            pageLoading: false,
            rowData: success.result.rows || [],
            rowMeta: {
              ...(success.meta || {}),
              current_count: success.meta.data_count,
            },
          });
          try {
            this.scroll_container.scrollTo({ behavior: "smooth", top: 0 });
          } catch (e) { }
        },
        (error) => {
          this.setState({
            error: true,
            loading: false,
            rowData: [],
            rowMeta: {},
          });
          showErrorInNotification(error);
        }
      )
      .forId(props.reconciler_id)
      .connect(props.domains.reconciliation);

    this.list_services_fordatatype = RESTExecutor.list()
      .config({
        label: "datatype_services",
        params: {
          pagination: false,
        },
      })
      .callbacks(
        () => {
          console.log("listed for manual");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.allData);

    let reconciler = this.props.reconciler || {};

    if (props.type === OURS_KEY) {
      console.log("listing source and service for ours");
      this.list_services_fordatatype
        .forId(reconciler.our_data_type_id)
        .execute();
    } else {
      console.log("listing source and service for theirs");
      this.list_services_fordatatype
        .forId(reconciler.their_data_type_id)
        .execute();
    }

    this.list_unreconciled_data.execute();

    this.removeWithIndex = this.removeWithIndex.bind(this);
  }

  resetSelected = () => {
    this.setState({
      selectedID: null,
    });
  };
  resetAndRefresh = () => {
    this.setState(
      {
        selectedID: null,
        loading: true,
        pageLoading: true,
        error: false,
      },
      () => {
        this.list_unreconciled_data.execute();
      }
    );
  };
  removeWithIndex = (index, other_id) => {
    // to remove reconciled data with given index

    let returning_data = {
      removed_index: false,
      next_selected: false,
      next_selected_id: null,
      next_selected_index: null,
      next_selected_rule: {},
    };

    let removed_count = 1;

    if (index == null) {
      console.log("Trying to delete null index item");
      return returning_data;
    }
    returning_data["removed_index"] = true;

    this.setState({ selectedID: null, error: false });
    // to remove reconciled data with given index
    let rowData = JSON.parse(JSON.stringify(this.state.rowData || []));
    let rowMeta = this.state.rowMeta || {};
    let removed_transaction = (rowData.splice(index, 1) || [])[0];

    if (removed_transaction.id) {
      console.log("removing txn id", removed_transaction, other_id);
      // transaction is removed
      // check if other id exist in this list
      //remove is exist
      let existing_id_index = lodash.findIndex(rowData, function (o) {
        return o.id == other_id;
      });
      console.log("Existing index", existing_id_index);
      if (existing_id_index >= 0) {
        //other transaction exist here too
        removed_count = 2;
        rowData.splice(existing_id_index, 1);
        console.log("new data after 2", rowData);
      }
    }

    let next_txn_to_select = rowData[0] || {};

    if (rowMeta.current_count == removed_count) {
      this.setState({ loading: true });
      let currentPage = parseInt(rowMeta.pagination.split("/")[0]);
      this.list_unreconciled_data
        .config({
          params: {
            ...this.state.filter_query,
            page: currentPage > 1 ? currentPage - 1 : 1,
          },
        })
        .execute();
      // refresh data needed since this being last transaction for given page
    } else {
      rowMeta = {
        ...rowMeta,
        current_count: rowMeta.current_count - removed_count,
      };

      console.log("next txn", next_txn_to_select);
      if (next_txn_to_select.id != null) {
        // auto select next row
        let rules = next_txn_to_select.rules || [];
        this.setState({ selectedID: next_txn_to_select.id });
        returning_data["next_selected"] = true;
        returning_data["next_selected_id"] = next_txn_to_select.id;
        returning_data["next_selected_rule"] = rules[0] || {};
        returning_data["next_selected_index"] = 0;
        returning_data["next_selected_transaction"] = next_txn_to_select;
      }
    }

    this.setState({
      rowData,
      rowMeta,
    });
    return returning_data;
  };

  getParams = () => {
    let params = JSON.parse(JSON.stringify(this.state.filter_query));

    return params;
  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };

  render() {
    const {
      type,
      selectedID,
      loading,
      filterVisible,
      filter_query,
      hasFilter,
      rowData,
      rowMeta,
    } = this.state;

    let list_unreconciled_data_resp = this.list_unreconciled_data.response();
    let list_unreconciled_data_data = list_unreconciled_data_resp.result || {};

    let list_service_fordatatype_resp =
      this.list_services_fordatatype.response();
    let service_list =
      (list_service_fordatatype_resp.result &&
        list_service_fordatatype_resp.result.rows) ||
      [];

    // let rowData = list_unreconciled_data_data.rows || [];
    // let rowMeta = list_unreconciled_data_resp.meta || {};

    const sort_menu = (
      <Menu
        onClick={(params) => {
          console.log("params ", params);
          this.setState({
            selectedID: null,
            loading: true,
          });
          typeof this.props.onSelectedID === "function" &&
            this.props.onSelectedID(null);
          this.stateUpdater({
            stateKey: "filter_query",
            valueKey: "order",
            appendObj: {
              page: 1,
            },
            value: JSON.stringify([params.key]),
            callback: () => {
              this.list_unreconciled_data
                .config({
                  params: {
                    ...this.getParams(),
                  },
                })
                .execute();
            },
          });
        }}
      >
        <Menu.Item key="-amount">Amount(High to Low)</Menu.Item>
        <Menu.Item key="amount">Amount(Low to High)</Menu.Item>
        <Menu.Item key="-txn_date">Txn Date(Recent First)</Menu.Item>
        <Menu.Item key="txn_date">Txn Date(Old First)</Menu.Item>
      </Menu>
    );

    return (
      <div style={{ width: "40%", boxShadow: COLORS.unreconciled_box_shadow }}>
        <PopUpForm
          forCreate={true}
          show_title_only
          title="Split Transaction"
          open={!!this.state.selectedSplitTxnID}
          onClose={() => {
            this.setState({
              selectedSplitTxnID: null
            })
          }}
          initialData={this.state.splitData}
          networkState={this.splitTransaction.response()}
          fields={[
            {
              name: "Amount to Split",
              index: 'amount',
              placeholder: "Amount to Split",
              type: 'number',
              required: true
            }
          ]}
          onSubmit={(data) => {
            this.splitTransaction.execute({
              ...data,
              txn_id: this.state.selectedSplitTxnID
            })
          }}
        />
        <Modal
          visible={this.state.view_transaction_modal}
          width={"90%"}
          destroyOnClose
          footer={null}
          centered
          className="transaction-modal"
          onCancel={() => {
            this.setState({
              view_transaction_modal: false,
              view_transaction_id: null,
            });
          }}
        >
          <ModalTransactionDetail
            onClose={() => {
              this.setState({
                view_transaction_modal: false,
                view_transaction_id: null,
              });
            }}
            isModal={true}
            match={{
              params: {
                transaction_id: this.state.view_transaction_id,
              },
            }}
            transaction_id={this.state.view_transaction_id}
          />
        </Modal>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <div
            className="unreconciled-top"
            style={{
              padding: 8,
              backgroundColor: COLORS.white,
              boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
              zIndex: 9,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingTop: 0,
                paddingBottom: 20,
                // padding:''
              }}
            >
              {this.props.toggleRender}
              {/* <span className='sub-heading-3'>OURS</span>
                &nbsp;&nbsp;&nbsp;
                <span className='heading-2' style={{
                  color:COLORS.primary
                }}>SCB INR Ledger (NMB)</span>
                &nbsp;&nbsp;&nbsp;
                <SyncAltRounded titleAccess="Switch OURS and THEIRS" className='toggle-icon hand-cursor' />
               */}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  className="hand-cursor"
                  onClick={() => {
                    this.setState({
                      filterVisible: !filterVisible,
                    });
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <FilterListOutlined
                    className="filter-icon"
                    style={{
                      color: hasFilter ? COLORS.success_primary : null,
                    }}
                  />
                  &nbsp;
                  {filterVisible ? "Hide" : "Show"} Filters
                  {filterVisible ? (
                    <ExpandLessOutlined />
                  ) : (
                    <ExpandMoreOutlined />
                  )}
                </div>
                &nbsp;
                <Dropdown
                  overlay={sort_menu}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <div
                    style={{ marginLeft: 20 }}
                    className="ant-dropdown-link hand-cursor"
                    href="#"
                  >
                    Sort By <KeyboardArrowDownOutlined type="down" />
                  </div>
                </Dropdown>
                <RefreshOutlined
                  style={{
                    marginLeft: 20,
                  }}
                  titleAccess="Refresh"
                  onClick={() => {
                    this.setState({
                      selectedID: null,
                      loading: true,
                    });
                    typeof this.props.onSelectedID === "function" &&
                      this.props.onSelectedID(null);
                    this.list_unreconciled_data.execute();
                  }}
                  className="menu-icon main-icon hand-cursor"
                />
              </div>
              {typeof this.props.onModeChange === "function" && (
                <CustomSwitch
                  title="Switch between Reconcile and Batch"
                  value={this.props.mode}
                  trueItem="RECONCILE"
                  falseItem="BATCH"
                  onChange={(value) => {
                    this.props.onModeChange(value);
                  }}
                />
              )}
            </div>
            {filterVisible && (
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    paddingTop: 20,
                  }}
                >
                  <Input.Search
                    placeholder="Search Query"
                    style={{
                      marginTop: 0,
                      marginBottom: 10,
                      marginRight: 10,
                      width: 200,
                    }}
                    value={filter_query.query}
                    onChange={(e) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "query",
                        value: e.target.value,
                      });
                    }}
                  />
                  <DatePicker
                    placeholder="Transaction Date"
                    style={{
                      marginTop: 0,
                      marginBottom: 10,
                      marginRight: 10,
                      width: 200,
                    }}
                    value={
                      filter_query.txn_date
                        ? moment(filter_query.txn_date, "YYYY-MM-DD")
                        : null
                    }
                    format="YYYY-MM-DD"
                    onChange={(date, dateString) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "txn_date",
                        value: dateString,
                      });
                    }}
                  />

                  <Select
                    allowClear
                    showSearch
                    className={
                      filter_query.service_id ? "filter-option-selected" : ""
                    }
                    style={{
                      marginTop: 0,
                      marginBottom: 10,
                      marginRight: 10,
                      width: 200,
                    }}
                    placeholder="Select Service"
                    value={filter_query.service_id}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value, e) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "service_id",
                        value: value,
                      });
                    }}
                  >
                    {service_list.map((item, index) => {
                      let source = item;

                      return (
                        <Select.Option
                          title={source.name}
                          value={item.id}
                          key={item.id}
                        >
                          {source.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  <Select
                    allowClear
                    showSearch
                    className={
                      filter_query.txn_type ? "filter-option-selected" : ""
                    }
                    style={{
                      marginTop: 0,
                      marginBottom: 10,
                      marginRight: 10,
                      width: 200,
                    }}
                    placeholder="Type"
                    value={filter_query.txn_type}
                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onChange={(value, e) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "txn_type",
                        value: value,
                      });
                    }}
                  >
                    <Select.Option value={"D"} key={"D"}>
                      Debit
                    </Select.Option>
                    <Select.Option value={"C"} key={"C"}>
                      Credit
                    </Select.Option>
                    <Select.Option value={"N/A"} key={"N/A"}>
                      N/A
                    </Select.Option>
                  </Select>
                  <InputNumber
                    placeholder="Amount"
                    style={{
                      marginTop: 0,
                      marginBottom: 10,
                      marginRight: 10,
                      width: 200,
                    }}
                    value={filter_query.amount}
                    onChange={(value) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "amount",
                        value: value,
                      });
                    }}
                  />
                  <InputNumber
                    placeholder="Offset"
                    disabled={!filter_query.amount}
                    style={{
                      marginTop: 0,
                      marginBottom: 10,
                      marginRight: 10,
                      width: 200,
                    }}
                    value={filter_query.offset}
                    onChange={(value) => {
                      this.stateUpdater({
                        stateKey: "filter_query",
                        valueKey: "offset",
                        value: value,
                      });
                    }}
                  />
                  <CustomSwitch
                  title="Switch between Batched Transaction and All"
                  value={filter_query.aggregated?"Batched Only":"All"}
                  trueItem={"Batched Only"}
                  falseItem={"All"}
                  style={{
                    marginTop: 0,
                    marginBottom: 10,
                    marginRight: 10,
                    width: 200
                  }}
                  onChange={(value) => {
                    this.stateUpdater({
                      stateKey: "filter_query",
                      valueKey: "aggregated",
                      value: value=="Batched Only"?true:false,
                    });
                  }}
                />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    paddingTop: 8,
                    paddingBottom: 8,
                  }}
                >
                  <CustomButton
                    className="primary-btn"
                    onClick={() => {
                      this.setState({
                        selectedID: null,
                        pageLoading: true,
                        hasFilter: true,
                      });
                      typeof this.props.onSelectedID === "function" &&
                        this.props.onSelectedID(null);
                      this.list_unreconciled_data
                        .config({
                          params: {
                            ...this.getParams(),
                          },
                        })
                        .execute();
                    }}
                    label="FILTER"
                  />

                  <CustomButton
                    className="danger-btn"
                    onClick={() => {
                      this.setState(
                        {
                          filter_query: {
                            per_page: 20,
                            page: 1,
                            source_id: this.props.source_id,
                          },
                          pageLoading: true,
                          selectedID: null,
                          hasFilter: false,
                        },
                        () => {
                          typeof this.props.onSelectedID === "function" &&
                            this.props.onSelectedID(null);
                          this.list_unreconciled_data
                            .config({
                              params: {
                                ...this.getParams(),
                              },
                            })
                            .execute();
                        }
                      );
                    }}
                    label="CLEAR ALL"
                  />
                  {/* <Button type='primary' size='small' style={{marginLeft:4,marginRight:4}}
                onClick={()=>{
                  this.setState({
                    selectedID:null,
                    pageLoading:true,
                    hasFilter:true

                  })
                  typeof this.props.onSelectedID==='function'&&this.props.onSelectedID(null);
                  this.list_unreconciled_data.config({
                    params:{
                      ...this.getParams()
                    }
                  }).execute()
                }}
                >Filter</Button> */}
                  {/* <Button type='danger' size='small' onClick={()=>{
                  this.setState({
                    filter_query:{},
                    pageLoading:true,
                    selectedID:null,
                    hasFilter:false
                  },()=>{
                    typeof this.props.onSelectedID==='function'&&this.props.onSelectedID(null);
                    this.list_unreconciled_data.config({
                      params:{
                        ...this.getParams()
                      }
                    }).execute()
                  })
                }}>Clear All</Button> */}
                </div>
              </div>
            )}
          </div>
          <ErrorWrapper
            error={list_unreconciled_data_resp}
            onReload={() => {
              this.list_unreconciled_data.execute();
            }}
          >
            <div
              ref={(ref) => {
                this.scroll_container = ref;
              }}
              style={{
                // display: 'flex',
                // flexDirection: 'column',
                overflowY: "scroll",
                // flex:1,
                height: "100%",
                padding: "0px 10px 0px 12px",
                backgroundColor: "rgba(0,0,0,0.02)",
                // paddingLeft:12,paddingRight:12
              }}
            >
              <Table
                loading={list_unreconciled_data_resp.fetching}
                className="padding-top-table main-table no-separator-table no-lr-padding-table  "
                style={
                  {
                    // backgroundColor:'inherit'
                  }
                }
                showHeader={false}
                locale={{
                  emptyText: this.state.error ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        height: "100%",
                        minHeight: 300,
                      }}
                    >
                      <center>
                        <Tag>
                          There was some error fetching unreconciled
                          transactions.
                          <Button
                            onClick={() => {
                              this.setState({
                                error: false,
                                loading: true,
                              });
                              this.list_unreconciled_data.execute();
                            }}
                            type="link"
                          >
                            Try Again
                          </Button>
                        </Tag>
                      </center>
                    </div>
                  ) : null,
                }}
                pagination={{
                  size: "small",
                  onChange: (current, size) => {
                    console.log(current, size);
                    this.setState({
                      selectedID: null,
                      pageLoading: true,
                    });
                    typeof this.props.onSelectedID === "function" &&
                      this.props.onSelectedID(null);
                    this.stateUpdater({
                      stateKey: "filter_query",
                      appendObj: {
                        per_page: size,
                        page: current,
                      },
                      callback: () => {
                        console.log("calling");
                        this.list_unreconciled_data
                          .config({
                            params: {
                              ...this.getParams(),
                            },
                          })
                          .execute();
                      },
                    });
                  },
                  defaultCurrent: 1,
                  current:
                    rowMeta.pagination &&
                    parseInt(rowMeta.pagination.split("/")[0]),
                  pageSize: rowMeta && rowMeta.requested_count,
                  total: rowMeta && rowMeta.total_count,
                  showTotal: (total, range) =>
                    `${formatMoney(range[0], 0)}-${formatMoney(
                      range[1],
                      0
                    )} of ${formatMoney(total, 0)} items`,
                }}
                dataSource={rowData}
                columns={[
                  {
                    key: "tab",
                    render: (record, data, index) => {
                      return (
                        <TransactionReconcileItem
                          onSplit={() => {
                            this.setState({
                              selectedSplitTxnID: record.txn_id
                            })
                          }}
                          selectedID={selectedID}
                          isRuleSelector
                          selectedRule={this.props.selected_rule}
                          itemID={record.id}
                          onViewDetailClicked={(id) => {
                            this.setState({
                              view_transaction_id: id,
                              view_transaction_modal: true,
                            });
                          }}
                          onSelected={(id, data) => {
                            this.setState({ selectedID: id }, () => {
                              typeof this.props.onSelectedID === "function" &&
                                this.props.onSelectedID(id, data, index);
                            });
                          }}
                          onRuleSelected={(id, data, rule) => {
                            this.setState({ selectedID: id }, () => {
                              typeof this.props.onRuleSelected === "function" &&
                                this.props.onRuleSelected(
                                  id,
                                  data,
                                  rule,
                                  index
                                );
                            });
                          }}
                          data={record}
                          key={index}
                        />
                      );
                    },
                  },
                ]}
              />
              {/* {loading?<Spin style={{
                display:'flex',
                flexDirection:'column',
                justifyContent:'center',
                alignItems:'center',
                height:'100%',
                minHeight:300
              }}/>:
              this.state.error?
               */}
              {/* <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height:'100%',
                minHeight:300
              }}>
                <center>
                  <Tag>There was some error fetching unreconciled transactions.
                    <Button onClick={()=>{
                      this.setState({
                        error:false,
                        loading:true
                      });
                      this.list_unreconciled_data.execute()
                    }} type='link'>Try Again</Button>
                    </Tag></center>
              </div>  */}
            </div>
          </ErrorWrapper>
        </div>
      </div>
    );
  }
  componentDidMount() {
    // this.list_notifications.execute();

    typeof this.props.onRef === "function" && this.props.onRef(this);
  }

  componentWillUnmount() {
    typeof this.props.onRef === "function" && this.props.onRef(undefined);
  }

  //   componentDidUpdate = (prevProps) => {
  //     if (this.props.type !== prevProps.type) {
  //         this.reconciler_id = this.props.reconciler_id;
  //         this.setState({
  //           type: this.props.type,
  //           selectedID: null,
  //           loading: true,
  //           error:false,
  //           filterVisible:false,
  //           filter_query: {
  //             per_page: 100,
  //             page: 1
  //           }
  //         })
  //         this.list_unreconciled_data.config({
  //           label: this.props.type === OURS_KEY ? 'our_manual_unreconciled' : 'their_manual_unreconciled'
  //         }).execute()
  //         // fetch the new product based and set it to the state of the component
  //     };
  // };
}

export default ManualReconcilerRuleSelector = withDomains(
  ManualReconcilerRuleSelector,
  "reconciliation",
  "allData"
);
